export default __webpack_public_path__ + "cc11986934bdeb76f98973659f28376d.svg";